export default __webpack_public_path__ + "static/micro-finance-solutions-4f4558049a66ceac9eee2c70fecd905b.png";